import styled from '@emotion/styled'
import { css } from '@emotion/react'

const sectionStyles = ({ theme }) => css`
  label: leroy-merlin-pay-banner;

  background: ${theme.colors.white};
  padding: 0 ${theme.spacings.giga} ${theme.spacings.tera};
`

const titleWrapperStyles = ({ theme }) => css`
  label: leroy-merlin-pay-banner__title-wrapper;

  padding-top: ${theme.spacings.tera};
  margin-bottom: ${theme.spacings.tera};

  h2 {
    font-weight: ${theme.font.weight.regular};
  }

  ${theme.media.mega} {
    padding-top: ${theme.spacings.zetta};
  }
`

const bannersLinkStyles = () => css`
  label: leroy-merlin-pay-banner__link;

  display: block;
`

const bannerImageStyles = () => css`
  label: leroy-merlin-pay-banner__image;

  display: block;
  width: 100%;
  height: auto;
`

export const Section = styled('section')(sectionStyles)
export const TitleWrapper = styled('div')(titleWrapperStyles)
export const BannersLink = styled('a')(bannersLinkStyles)
export const BannerImage = styled('img')(bannerImageStyles)
